<template>
    <div class="atencion-medica">

      <div class="row mb-3">
        <div class="col-md-10">
          <h1>Resumen de Atención Médica</h1>
        </div>
        <div class="col-md-2">
          <button type="button" class="btn btn-light mb-1 w-100" @click="atencionMedicaPDF()">
            <span class="material-symbols-outlined" style="font-size: 20px; color: blue;">print</span>
            Imprimir
          </button>
        </div>
      </div>
      
      <!-- Datos generales de la atención -->
      <section v-if="atencion" class="container">
    <h2>Información General</h2>
    <div class="row mb-3">
      <div class="col-md-6">
        <p><strong>Número:</strong> {{ atencion.numero }}</p>
        <p><strong>Tipo:</strong> {{ atencion.tipo === 'I' ? 'INICIAL' : (atencion.tipo === 'S' ? 'SUBSECUENTE' : 'Desconocido') }}</p>
        <p><strong>Paciente:</strong> {{ atencion.nombrePaciente }}</p>
        <p><strong>Documento:</strong> {{ atencion.documentoPaciente }}</p>
        <p><strong>Sexo:</strong> {{ atencion.sexoPaciente === 'M' ? 'MASCULINO' : (atencion.sexoPaciente === 'F' ? 'FEMENINO' : 'Desconocido') }}</p>
      </div>
      <div class="col-md-6">
        <p><strong>Fecha de la Cita:</strong> {{ getFormattedDate(atencion.fechaCita) }}</p>
        <p><strong>Médico:</strong> {{ atencion.nombreMedico }}</p>
        <p><strong>Especialidad:</strong> {{ atencion.nombreEspecialidad }}</p>
      </div>
    </div>
    <p><strong>Motivo:</strong> {{ atencion.motivo }}</p>
  </section>
  
      <!-- Datos biométricos -->
      <section v-if="biometricosFiltrados.length">
        <h2>Datos Biométricos</h2>
        <ul>
          <li v-for="biometrico in biometricosFiltrados" :key="biometrico.idBiomAten">
            {{ biometrico.biometriaNombre }}: {{ biometrico.valor }}
          </li>
        </ul>
      </section>
  
      <!-- Antecedentes -->
      <section v-if="antecedentesFiltrados.length">
        <h2>Antecedentes</h2>
        <ul>
          <li v-for="antecedente in antecedentesFiltrados" :key="antecedente.idAnteAten">
            {{ antecedente.tipo === 'P' ? 'PERSONAL' : (antecedente.tipo === 'F' ? 'FAMILIAR' : 'Desconocido') }} - 
            {{ antecedente.parentesco }} -
            {{ antecedente.antecedenteNombre }} - 
            {{ antecedente.observacion }}
          </li>
        </ul>
      </section>
  
      <!-- Revisión de órganos y sistemas -->
      <section v-if="organosFiltrados.length">
        <h2>Revisión de Órganos y Sistemas</h2>
        <ul>
          <li v-for="organo in organosFiltrados" :key="organo.idAnatAten">
            {{ organo.anatomiaNombre }}: {{ organo.observacion }}
          </li>
        </ul>
      </section>
  
      <!-- Exámenes físicos -->
      <section v-if="examenesFiltrados.length">
        <h2>Examen Físico</h2>
        <ul>
          <li v-for="examen in examenesFiltrados" :key="examen.idExamAten">
            {{ examen.examenFisicoNombre }}: {{ examen.observacion }}
          </li>
        </ul>
      </section>
  
      <!-- Diagnósticos -->
      <section v-if="diagnosticos.length">
        <h2>Diagnósticos</h2>
        <ul>
          <li v-for="diagnostico in diagnosticos" :key="diagnostico.idDiagAten">
            {{ diagnostico.diagnosticoNombre }} ({{ diagnostico.diagnosticoCodigo }})
          </li>
        </ul>
      </section>
    </div>
  </template>
  
  <script>
  import dateFormat from '@/modules/dateFormat.js';
  import api        from "@/services/api";
  import config     from '@/config.js'
  
  export default {
    props: {
      p_idAtencion: {
        type: Number,
        required: true
      }
    },  
    data() {
      return {
        atencion: null,
        biometricos: [],
        antecedentes: [],
        organos: [],
        examenes: [],
        diagnosticos: []
      };
    },
    computed: {
      biometricosFiltrados() {
        return this.biometricos.filter(biometrico => biometrico.valor !== '' && biometrico.valor !== null && biometrico.valor !== undefined );
      },
      antecedentesFiltrados() {
        return this.antecedentes.filter(antecedente => antecedente.observacion !== '-' && antecedente.observacion !== null && antecedente.observacion !== undefined );
      },
      organosFiltrados() {
        return this.organos.filter(organo => organo.observacion !== 'Sin patología' && organo.observacion !== null && organo.observacion !== undefined );
      },
      examenesFiltrados() {
        return this.examenes.filter(examen => examen.observacion !== '-' && examen.observacion !== null && examen.observacion !== undefined );
      }
    },
    mounted() {
      this.loadAtencion();
      this.loadBiometricos();
      this.loadAntecedentes();
      this.loadOrganos();
      this.loadExamenes();
      this.loadDiagnosticos();
    },
    methods: {
      getFormattedDate(date) {
        return dateFormat.getFormattedDate(date);
      },
      atencionMedicaPDF() {
        const url = `${config.apiReportesUrl}/8/${this.p_idAtencion}`;
        window.open(url, '_blank');
      },
      loadAtencion() {
          api.get('/vwatencions/' + this.p_idAtencion)
          .then(response => {
            this.atencion = response.data;
          })
          .catch(error => {
            console.error('Error loading atencion:', error);
          });
      },
      loadBiometricos() {
        api.get('/vwbiomatens/idatencion/' + this.p_idAtencion)
          .then(response => {
            this.biometricos = response.data;
          })
          .catch(error => {
            console.error('Error loading biometricos:', error);
          });
      },
      loadAntecedentes() {
        api.get('/vwanteatens/idatencion/' + this.p_idAtencion)
          .then(response => {
            this.antecedentes = response.data;
          })
          .catch(error => {
            console.error('Error loading antecedentes:', error);
          });
      },
      loadOrganos() {
        api.get('/vwanatatens/idatencion/' + this.p_idAtencion)
          .then(response => {
            this.organos = response.data;
          })
          .catch(error => {
            console.error('Error loading organos:', error);
          });
      },
      loadExamenes() {
        api.get('/vwexamatens/idatencion/' + this.p_idAtencion)
          .then(response => {
            this.examenes = response.data;
          })
          .catch(error => {
            console.error('Error loading examenes:', error);
          });
      },
      loadDiagnosticos() {
        api.get('/vwdiagatens/idatencion/' + this.p_idAtencion)
          .then(response => {
            this.diagnosticos = response.data;
          })
          .catch(error => {
            console.error('Error loading diagnosticos:', error);
          });
      },
    }
  };
  </script>
  
  <style scoped>
  .atencion-medica {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    max-width: 100%px;
    margin: 20px auto;
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  }
  
  .atencion-medica h1, .atencion-medica h2 {
    color: #0056b3;
  }
  
  .atencion-medica h1 {
    border-bottom: 2px solid #0056b3;
    padding-bottom: 10px;
    margin-bottom: 20px;
  }
  
  .atencion-medica h2 {
    border-bottom: 1px solid #ccc;
    padding-bottom: 5px;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  
  .atencion-medica p, .atencion-medica li {
    color: #333;
    line-height: 1.6;
  }
  
  .atencion-medica ul {
    list-style-type: none;
    padding: 0;
  }
  
  .atencion-medica li {
    margin-bottom: 5px;
    background-color: #f8f9fa;
    border-left: 5px solid #0056b3;
    padding: 10px 15px;
    border-radius: 5px;
  }
  
  .atencion-medica section {
    margin-bottom: 20px;
  }
  
  .button {
    display: inline-block;
    background-color: #007bff;
    color: white;
    padding: 10px 20px;
    text-decoration: none;
    border-radius: 5px;
    text-align: center;
    transition: background-color 0.3s;
  }
  
  .button:hover {
    background-color: #0056b3;
  }
  </style>
  